module.exports = __webpack_public_path__ + "img/spotify.d32755f3.png";